<div class="list-page kapea" style="max-width: 1200px">
  <h3 style="margin: 0">Myyntiraportti</h3>

  <form novalidate class="ylaosan-kontrollit" style="margin: 16px 0">
    <div style="display: flex">
      <mat-form-field style="max-width: 100px">
        <mat-label>Alku</mat-label>
        <input matInput monthPicker [matDatepicker]="dp" placeholder="Alku" tahtiOhjeeseen [formField]="lomake.month" />
        <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
        <mat-datepicker #dp startView="year" (monthSelected)="chosenMonthHandler($event, dp)" panelClass="kuukausi-valitsin"></mat-datepicker>
      </mat-form-field>
      <app-primary-button style="margin-left: 10px" (click)="lataaMyyntiraportti()" actionId="Lataa myyntiraportti koneelle" [actionContext]="[lomake().value()]" additionalClass="mat-elevation-z4" matIcon="cloud_download">Lataa</app-primary-button>
    </div>
  </form>

  @if (commonError()) {
    <div class="lemon-error" style="margin: 0 0 15px 10px">{{ commonError() }}</div>
  }

  <h3 style="margin: 0" style="margin-top: 2em">Selvitettävät tiimeittäin</h3>

  @if (commonErrorSelvitettavat()) {
    <div class="lemon-error" style="margin: 0 0 15px 10px">{{ commonErrorSelvitettavat() }}</div>
  }

  <app-primary-button (click)="lataaSelvitettavatRaportti()" actionId="Lataa selvitettävät raportti koneelle" additionalClass="mat-elevation-z4" matIcon="cloud_download">Lataa</app-primary-button>

  <h3 style="margin: 0" style="margin-top: 2em">Päättyneet- ja alkaneet sopimukset</h3>

  <form novalidate style="margin: 16px 0">
    <div style="display: flex">
      <mat-form-field style="max-width: 100px; margin-right: 20px">
        <input name="paattyneetSopimuksetAlkaa" type="text" monthPicker [matDatepicker]="paattyneetSopimuksetAlkaaPicker" tahtiOhjeeseen [formField]="paattyneetSopimuksetLomake.alkaa" placeholder="Alku" matInput data-lpignore="true" />
        <mat-datepicker-toggle matSuffix [for]="paattyneetSopimuksetAlkaaPicker"></mat-datepicker-toggle>
        <mat-datepicker #paattyneetSopimuksetAlkaaPicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field style="max-width: 100px">
        <input name="paattyneetSopimuksetLoppuu" type="text" monthPicker [matDatepicker]="paattyneetSopimuksetLoppuuPicker" tahtiOhjeeseen [formField]="paattyneetSopimuksetLomake.loppuu" placeholder="Loppu" matInput data-lpignore="true" />
        <mat-datepicker-toggle matSuffix [for]="paattyneetSopimuksetLoppuuPicker"></mat-datepicker-toggle>
        <mat-datepicker #paattyneetSopimuksetLoppuuPicker></mat-datepicker>
      </mat-form-field>
      <app-primary-button style="margin-left: 10px" (click)="lataaPaattyneetSopimuksetCsv()" actionId="Lataa päättyneet sopimukset raportti koneelle" [actionContext]="[paattyneetSopimuksetLomake().value()]" additionalClass="mat-elevation-z4" matIcon="cloud_download"> Lataa päättyneet sopimukset </app-primary-button>
      <app-primary-button style="margin-left: 10px" (click)="lataaAlkaneetSopimuksetCsv()" actionId="Lataa alkaneet sopimukset raportti koneelle" [actionContext]="[paattyneetSopimuksetLomake().value()]" additionalClass="mat-elevation-z4" matIcon="cloud_download"> Lataa alkaneet sopimukset </app-primary-button>
    </div>
  </form>

  @if (commonErrorPaattyneetSopimukset()) {
    <div class="lemon-error" style="margin: 0 0 15px 10px">{{ commonErrorPaattyneetSopimukset() }}</div>
  }

  <h3 style="margin: 0" style="margin-top: 2em">Hinnanmuutokset</h3>

  <form novalidate style="margin: 16px 0">
    <div style="display: flex">
      <mat-form-field style="max-width: 100px; margin-right: 20px">
        <input name="hinnanmuutoksetAlkaa" type="text" monthPicker [matDatepicker]="hinnanmuutoksetAlkaaPicker" tahtiOhjeeseen [formField]="hinnanmuutoksetLomake.alkaa" placeholder="Alku" matInput data-lpignore="true" />
        <mat-datepicker-toggle matSuffix [for]="hinnanmuutoksetAlkaaPicker"></mat-datepicker-toggle>
        <mat-datepicker #hinnanmuutoksetAlkaaPicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field style="max-width: 100px">
        <input name="hinnanmuutoksetLoppuu" type="text" monthPicker [matDatepicker]="hinnanmuutoksetLoppuuPicker" tahtiOhjeeseen [formField]="hinnanmuutoksetLomake.loppuu" placeholder="Loppu" matInput data-lpignore="true" />
        <mat-datepicker-toggle matSuffix [for]="hinnanmuutoksetLoppuuPicker"></mat-datepicker-toggle>
        <mat-datepicker #hinnanmuutoksetLoppuuPicker></mat-datepicker>
      </mat-form-field>
      <app-primary-button style="margin-left: 10px" (click)="lataaHinnanmuutoksetCsv()" actionId="Lataa hinnanmuutokset raportti koneelle" [actionContext]="[hinnanmuutoksetLomake().value()]" additionalClass="mat-elevation-z4" matIcon="cloud_download">Lataa</app-primary-button>
    </div>
  </form>

  @if (commonErrorHinnanmuutokset()) {
    <div class="lemon-error" style="margin: 0 0 15px 10px">{{ commonErrorHinnanmuutokset() }}</div>
  }

  <h3 style="margin: 0" style="margin-top: 2em">Reskontratilanne</h3>

  <form style="margin: 16px 0">
    <div style="display: flex">
      <mat-form-field style="max-width: 150px; margin-left: 10px; margin-right: 10px">
        <mat-label>Päivämäärä</mat-label>
        <input matInput type="text" name="reskontratilannePaiva" [matDatepicker]="reskontratilannePicker" [formField]="reskontratilanneLomake.reskontratilannePaiva" />
        <mat-datepicker-toggle matSuffix [for]="reskontratilannePicker"></mat-datepicker-toggle>
        <mat-datepicker #reskontratilannePicker></mat-datepicker>
      </mat-form-field>
      <app-primary-button (click)="lataaReskontratilanneExcel()" actionId="Lataa laskujen reskontratilanne koneelle" additionalClass="mat-elevation-z4" matIcon="cloud_download"> Lataa </app-primary-button>
    </div>
  </form>

  @if (kirjanpitajaOnDevaajaTaiTukiTaiMuutObservable | async) {
    <h3 style="margin: 0" style="margin-top: 2em">Ylisuoritukset ja erääntyneet</h3>

    <form style="margin: 16px 0">
      <div style="display: flex">
        <mat-form-field style="max-width: 150px; margin-left: 10px; margin-right: 10px">
          <mat-label>Päivämäärä</mat-label>
          <input matInput type="text" name="ylisuorituksetJaEraantyneetPaiva" [matDatepicker]="ylisuorituksetJaEraantyneetPicker" [max]="tanaan" [formField]="ylisuorituksetJaEraantyneetLomake.date" />
          <mat-datepicker-toggle matSuffix [for]="ylisuorituksetJaEraantyneetPicker"></mat-datepicker-toggle>
          <mat-datepicker #ylisuorituksetJaEraantyneetPicker></mat-datepicker>
          @if (naytaTulevaisuusvirhe()) {
            <mat-error>Päivä ei voi olla tulevaisuudessa.</mat-error>
          }
        </mat-form-field>
        <app-primary-button (click)="lataaYlisuorituksetJaEraantyneetCsv()" actionId="Lataa ylisuoritukset ja erääntyneet raportti koneelle" [actionContext]="[ylisuorituksetJaEraantyneetLomake().value()]" additionalClass="mat-elevation-z4" matIcon="cloud_download">Lataa</app-primary-button>
      </div>
    </form>

    @if (commonErrorYlisuorituksetJaEraantyneet()) {
      <div class="lemon-error" style="margin: 0 0 15px 10px">{{ commonErrorYlisuorituksetJaEraantyneet() }}</div>
    }
  }

  <h3 style="margin: 0" style="margin-top: 2em">Sopimustyyppien muutokset</h3>

  <form novalidate style="margin: 16px 0">
    <div style="display: flex">
      <mat-form-field style="max-width: 100px; margin-right: 20px">
        <input name="sopimustyyppienMuutoksetAlkaa" type="text" monthPicker [matDatepicker]="sopimustyyppienMuutoksetAlkaaPicker" tahtiOhjeeseen [formField]="sopimustyyppienMuutoksetLomake.alkaa" placeholder="Alku" matInput data-lpignore="true" />
        <mat-datepicker-toggle matSuffix [for]="sopimustyyppienMuutoksetAlkaaPicker"></mat-datepicker-toggle>
        <mat-datepicker #sopimustyyppienMuutoksetAlkaaPicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field style="max-width: 100px">
        <input name="sopimustyyppienMuutoksetLoppuu" type="text" monthPicker [matDatepicker]="sopimustyyppienMuutoksetLoppuuPicker" tahtiOhjeeseen [formField]="sopimustyyppienMuutoksetLomake.loppuu" placeholder="Loppu" matInput data-lpignore="true" />
        <mat-datepicker-toggle matSuffix [for]="sopimustyyppienMuutoksetLoppuuPicker"></mat-datepicker-toggle>
        <mat-datepicker #sopimustyyppienMuutoksetLoppuuPicker></mat-datepicker>
      </mat-form-field>
      <app-primary-button style="margin-left: 10px" (click)="lataaSopimustyyppienMuutoksetCsv()" actionId="Lataa sopimustyyppien muutokset raportti koneelle" [actionContext]="[sopimustyyppienMuutoksetLomake().value()]" additionalClass="mat-elevation-z4" matIcon="cloud_download">Lataa</app-primary-button>
    </div>
  </form>

  @if (commonErrorSopimustyyppienMuutokset()) {
    <div class="lemon-error" style="margin: 0 0 15px 10px">{{ commonErrorSopimustyyppienMuutokset() }}</div>
  }

  <h3 style="margin: 0" style="margin-top: 2em">Pöytälaatikko- ja taukosopimusten kestoraportti</h3>

  <form novalidate style="margin: 16px 0">
    <div style="display: flex">
      <mat-form-field style="max-width: 100px; margin-right: 20px">
        <input name="sopimustyyppienMuutoksetAlkaa" type="text" [matDatepicker]="poytalaatikkoJaTaukosopimustenPicker" tahtiOhjeeseen [formField]="poytalaatikkoJaTaukosopimustenKestotLomake.date" placeholder="Päivämäärä" matInput data-lpignore="true" />
        <mat-datepicker-toggle matSuffix [for]="poytalaatikkoJaTaukosopimustenPicker"></mat-datepicker-toggle>
        <mat-datepicker #poytalaatikkoJaTaukosopimustenPicker></mat-datepicker>
      </mat-form-field>
      <app-primary-button (click)="lataaPoytalaatikkoJaTaukosopimustenKestotCsv()" actionId="Lataa pöytälaatikko- ja taukosopimusten kestoraportti koneelle" [actionContext]="[poytalaatikkoJaTaukosopimustenKestotLomake().value()]" additionalClass="mat-elevation-z4" matIcon="cloud_download">Lataa</app-primary-button>
    </div>
  </form>

  @if (commonErrorPoytalaatikkoJaTaukosopimustenKestot()) {
    <div class="lemon-error" style="margin: 0 0 15px 10px">{{ commonErrorPoytalaatikkoJaTaukosopimustenKestot() }}</div>
  }

  <h3 style="margin: 0" style="margin-top: 2em">1755 Saamiset osakkailta ja omaisilta</h3>

  <form novalidate style="margin: 16px 0">
    <div style="display: flex">
      <mat-form-field style="max-width: 100px; margin-right: 20px">
        <input name="saamisetOsakkailtaJaOmaisiltaAlkaa" type="text" [matDatepicker]="saamisetOsakkailtaJaOmaisiltaPicker" tahtiOhjeeseen [formField]="saamisetOsakkailtaJaOmaisiltaLomake.date" placeholder="Päivämäärä" matInput data-lpignore="true" />
        <mat-datepicker-toggle matSuffix [for]="saamisetOsakkailtaJaOmaisiltaPicker"></mat-datepicker-toggle>
        <mat-datepicker #saamisetOsakkailtaJaOmaisiltaPicker></mat-datepicker>
      </mat-form-field>
      <app-primary-button style="margin-left: 10px" (click)="lataaSaamisetOsakkailtaJaOmaisiltaCsv()" actionId="Lataa 1755 Saamiset osakkailta ja omaisilta raportti koneelle" [actionContext]="[saamisetOsakkailtaJaOmaisiltaLomake().value()]" additionalClass="mat-elevation-z4" matIcon="cloud_download">Lataa</app-primary-button>
    </div>
  </form>

  @if (commonErrorSaamisetOsakkailtaJaOmaisilta()) {
    <div class="lemon-error" style="margin: 0 0 15px 10px">{{ commonErrorSaamisetOsakkailtaJaOmaisilta() }}</div>
  }

  @if (kirjanpitajaOnDevaajaTaiTukiTaiMuutObservable | async) {
    <h3 style="margin: 0" style="margin-top: 2em">Laskujen tuotteet</h3>

    <form novalidate style="margin: 16px 0">
      <div style="display: flex">
        <mat-form-field style="max-width: 100px; margin-right: 20px">
          <input name="laskujenTuotteetAlkaa" type="text" [matDatepicker]="laskujenTuotteetAlkaaPicker" tahtiOhjeeseen [formField]="laskujenTuotteetLomake.alkaa" placeholder="Alku" matInput data-lpignore="true" />
          <mat-datepicker-toggle matSuffix [for]="laskujenTuotteetAlkaaPicker"></mat-datepicker-toggle>
          <mat-datepicker #laskujenTuotteetAlkaaPicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field style="max-width: 100px">
          <input name="laskujenTuotteetLoppuu" type="text" [matDatepicker]="laskujenTuotteetLoppuuPicker" tahtiOhjeeseen [formField]="laskujenTuotteetLomake.loppuu" placeholder="Loppu" matInput data-lpignore="true" />
          <mat-datepicker-toggle matSuffix [for]="laskujenTuotteetLoppuuPicker"></mat-datepicker-toggle>
          <mat-datepicker #laskujenTuotteetLoppuuPicker></mat-datepicker>
        </mat-form-field>
        <app-primary-button style="margin-left: 10px" (click)="lataaLaskujenTuotteetCsv()" actionId="Lataa laskujen tuotteet raportti koneelle" [actionContext]="[laskujenTuotteetLomake().value()]" additionalClass="mat-elevation-z4" matIcon="cloud_download">Lataa</app-primary-button>
      </div>
    </form>

    @if (commonErrorLaskujenTuotteet()) {
      <div class="lemon-error" style="margin: 0 0 15px 10px">{{ commonErrorLaskujenTuotteet() }}</div>
    }

    <h3 style="margin: 0" style="margin-top: 2em">Asiakkaiden hinnat</h3>

    @if (commonErrorAsiakkaatJaHinnat()) {
      <div class="lemon-error" style="margin: 0 0 15px 10px">{{ commonErrorAsiakkaatJaHinnat() }}</div>
    }

    <app-primary-button (click)="lataaAsiakkaatJaHinnatCsv()" actionId="Lataa asiakkaiden hinnat raportti koneelle" additionalClass="mat-elevation-z4" matIcon="cloud_download">Lataa</app-primary-button>

    <h3 style="margin: 0" style="margin-top: 2em">Asiakkaiden hinnat ja liikevaihtoraportti</h3>

    @if (commonErrorAsiakkaatJaHinnatJaLiikevaihto()) {
      <div class="lemon-error" style="margin: 0 0 15px 10px">{{ commonErrorAsiakkaatJaHinnatJaLiikevaihto() }}</div>
    }

    <app-primary-button (click)="lataaAsiakkaatJaHinnatJaLiikevaihtoCsv()" actionId="Lataa asiakkaiden hinnat ja liikevaihto raportti koneelle" additionalClass="mat-elevation-z4" matIcon="cloud_download">Lataa</app-primary-button>
  }
</div>
